import classNames from "classnames";
import { useTranslation } from "react-i18next";

import Button from "features/components/Button";
import Tooltip from "features/components/Tooltip";
import WhiteDuckLogoIcon from "features/ui/Icons/WhiteDuckLogoIcon";

const DuckButton = ({
  onClick,
  isActive,
  tooltip,
  // "ViaDuck" is the product name and stays untranslated
  title = "ViaDuck",
}: {
  onClick: () => void;
  isActive?: boolean;
  tooltip?: string;
  title?: string;
}) => {
  const { t } = useTranslation();

  return (
    <Tooltip
      title={tooltip ?? t("duck:duck_button_tooltip")}
      placement="bottom-end"
      arrow={true}
    >
      <Button
        onClick={onClick}
        className={classNames(
          "pointer-events-auto hover:!bg-[#A06ACE] !bg-[#7E5A9C]",
          {
            "!bg-purple-400 hover:!bg-purple-400 !text-white": isActive,
          }
        )}
        data-testid="duck-open-cta"
        variant="contained"
        color="primary"
        size="small"
      >
        <WhiteDuckLogoIcon size={24} />
        {title}
      </Button>
    </Tooltip>
  );
};

export default DuckButton;
